<template>
  <!-- VGM管理 -->
   <div class="page-container-manage page-container-booking" id="vgmContainer">
    <el-form ref="searchFromRef" class="form-panel" label-position="top">
      <el-row class="content-panel manage-content-panel">
        <!-- 查询-start -->
     <el-row style="background-color:#fff; padding:10px 10px 0 10px; border-radius: 10px;">
        <el-row :gutter="10">
          <el-col :span="10">
            <el-form-item>
              <el-input size="small" placeholder="请输入单个或多个客户业务编号、订单号、提单号进行查询，多个单号用分号隔开" clearable v-model="nameComputed" :title="nameComputed">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="margin-top: 2px">
            <el-row>
              <el-button
                class="el-button-search"
                type="primary"
                size="small"
                plain
                @click="queryForm"
              >查询</el-button>
              <el-button
                type="primary"
                size="small"
                plain
                @click="resetForm"
              >重置</el-button>
              <el-button
              class="advanced-query-btn"
                type="primary"
                size="small"
                plain
                @click="changMoreInfoVisible"
                 v-if="!moreInfoVisible ? 'hidden' : ''"
              >显示高级查询
              <svg-icon icon-class="arrow-down" class="svg-change-color"></svg-icon>
              </el-button>
               <el-button
               class="advanced-query-btn"
                type="primary"
                size="small"
                plain
                @click="changMoreInfoVisible"
                v-if="moreInfoVisible ? 'hidden' : ''"
              >隐藏高级查询
              <svg-icon icon-class="arrow-up" class="svg-change-color"></svg-icon>
              </el-button>
            </el-row>
          </el-col>
        </el-row>
        <!-- 查询-end -->
        <!-- 高级查询-start -->
        <el-row class="content-panel title-fix advanced-query"
                v-show="moreInfoVisible">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="船公司:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_carrier"
                  :query-method="associate_queryMethod_carrier"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="custNameCn"
                  value-prop="custNameCn"
                  placeholder=""
                  v-model="searchData.carrierName"
                  @change="giveCsCustId"
                  size="mini"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="船名/航次:">
                    <el-associate
                      ref="vesselAssociate"
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="vesselName"
                      value-prop="vesselId"
                      placeholder=""
                      v-model="searchData.vesselName"
                      :title="searchData.vesselName"
                      size="mini"
                      name="vesselName"
                      @change="onChangeVessel"
                      case="upper"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-input
                      size="mini"
                      placeholder=""
                      clearable
                      v-model="searchData.voyage"
                      :title="searchData.voyage"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="创建日期从/到:">
                    <el-date-picker
                      v-model="searchData.startTime"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      default-time="00:00:00"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <label slot="label" class="label_no"></label>
                    <el-date-picker
                      v-model="searchData.endTime"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      default-time="23:59:59"
                      :picker-options="pickerOptions"
                      @change="changeEndTime"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="大船开航日期从/到:">
                    <el-date-picker
                      v-model="searchData.startEtd"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      default-time="00:00:00"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <label slot="label" class="label_no"></label>
                    <el-date-picker
                      v-model="searchData.endEtd"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      @change="changeEndEtd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="装货港:">
                <el-associate style="width: 100%;" :columns="associate_columns_po"
                              :query-method="associate_queryMethod_po" class="input_length" clearable
                              :query-length="0" :default-first-option="true" label-prop="portNameEn"
                              value-prop="mdPortId" placeholder="" v-model="searchData.polId" size="mini"
                              @change="onPolChange"
                              name="polName"
                              case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="卸货港:">
                <el-associate style="width: 100%;" :columns="associate_columns_po"
                              :query-method="associate_queryMethod_po" class="input_length" clearable
                              :query-length="0" :default-first-option="true" label-prop="portNameEn"
                              value-prop="mdPortId" placeholder="" v-model="searchData.podId" size="mini"
                              @change="onPodChange"
                              name="podName"
                              case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3" class="advanced-query-btns">
              <el-row type="flex" justify="end" align="middle" :gutter="10" class="el-row-margin">
                <el-button type="primary" size="small" plain @click="queryMoreForm" class="el-button-search">查询</el-button>
                <el-button type="primary" size="small" plain @click="resetMoreForm" >重置</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
        <!-- 高级查询-end -->
     </el-row>
        <!-- 状态栏-start -->
        <el-row>
          <el-col class="tabsContainer tab-module">
            <el-tabs
              type="border-card"
              v-model="activeName"
              @tab-click="handleClick"
            >
              <el-tab-pane
                :label="'全部(' + count0 + ')'"
                name="all"
              ></el-tab-pane>
              <el-tab-pane
                v-for="(item, index) in ebOrderStatusList"
                :key="index"
                :name="item.value"
              >
                <span slot="label">{{ item.name + '(' }}<span
                  :class="[item.count > 0? 'hasTabPane': '']">{{ item.count }}</span><span>{{ ')' }}</span></span>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
       <el-row class="state-panel">
        <!-- 状态栏-end -->

        <!-- 按钮栏-start -->
        <el-row style="background-color:#fff;padding:10px">

          <el-button type="primary" size="small" plain @click="btnAdd" class="el-button-search">新增</el-button>
          <el-button type="primary" size="small" plain @click="batchSubmit" >批量提交</el-button>
<!--          <el-button type="primary" size="small" plain @click="makeBLN()">导出</el-button>-->
<!--          <el-button type="info" size="small" plain @click="vgmExport">导出</el-button>-->
        </el-row>
        <!-- 按钮栏-end -->
        <!-- 表格-start -->
        <el-row style="padding: 0 1px">
          <hot-table ref="ebOrderTableRef" :data-source="ebOrderTableDataSource" :settings="tableSettings" @cellDblclick="dbClickMblNo">
          <hot-column :has-tip="true" data="mblNo" title="提单号" width="150"></hot-column>
          <hot-column :has-tip="true" data="custBizNo" title="客户业务编号" width="150"></hot-column>
          <hot-column :has-tip="true" data="vgmStatus" title="VGM状态" width="150" dictName="EB_VGM_STATUS"></hot-column>
          <hot-column :has-tip="true" data="vgmApprovalStatus" title="VGM提交状态" width="150" dictName="EB_VGM_SUB_STATUS"></hot-column>
          <hot-column :has-tip="true" data="carrierName" title="船公司" width="150"></hot-column>
          <hot-column :has-tip="true" data="vesselNameEn" title="船名" width="150"></hot-column>
          <hot-column :has-tip="true" data="voyage" title="航次" width="150"></hot-column>
          <hot-column :has-tip="true" data="creatorName" title="创建人" width="150"></hot-column>
          <hot-column :has-tip="true" data="createTime" title="创建时间" date-format="YYYY-MM-DD  HH:mm:ss" width="150"></hot-column>
          <hot-column :has-tip="true" data="etd" date-format="YYYY-MM-DD  HH:mm:ss" title="开航时间" width="150"></hot-column>
          <hot-column :has-tip="true" data="lastModifierName" title="修改人" width="150"></hot-column>
          <hot-column :has-tip="true" data="lastModifyTime" date-format="YYYY-MM-DD HH:mm:ss" title="修改时间" width="150"></hot-column>
        </hot-table>
          <!-- 分页start -->
          <div class="pg_div">
            <el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
                           :page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes"
                           :total="pageConfig.total" @current-change="handleCurrentChange"
                           @size-change="handleSizeChange"/>
          </div>
          <!-- 分页end -->
        </el-row>
        <!-- 表格-end -->
   </el-row>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ResizeObserver from "resize-observer-polyfill";
import {
  queryByNo,
  queryEbOrderByConditions,
  queryEbOrder,
  queryMoreEbOrder,
  batchSubmitVGM
} from "@/api/vgmManage"
import columnEditRenderer from "@/components/CustomRenderer/columnEditRenderer"
import ds, {dsc, ___} from '@/utils/daoService/DaoServiceClientES6Adapter'

import ebOrder from "@/api/ebOrder";
import {
  queryCarrierInfo,
  queryDictRows,
  queryPoInfo,
  queryVesselInfo,
  queryVoyageInfo
} from "@/api/commonService";
import addUpBox from "@/views/booking/AddUpBox";
import templateBookingUpBox from "@/views/booking/TemplateBookingUpBox";
import uploadGuaranteeUpBox from "@/views/booking/UploadGuaranteeUpBox";
import downloadAttachchUpBox from "@/views/booking/DownloadAttachmentUpBox";
import {
  batchCancel,
  batchSubmitBooking,
  batchUpdateOrderStatus,
  revokeSub,
  batchSubmit,
  batchRevokeSub
} from "@/api/bookingRequest";
import ebFtPlan from "@/api/ebFtPlan";
import ebParty from "@/api/ebParty";
import ebCargo from "@/api/ebCargo";
import {set} from 'js-cookie';
import columnLinkRenderer from "../../components/CustomRenderer/columnLinkRenderer"

export default {
  name: 'VGMManage',
  components: {
    columnEditRenderer,
    columnLinkRenderer
  },
  data() {
    return {
      resizeObserver: null,
      //查询条件
      no: "",
      //查询
      searchData: {
        carrierName: "",
        vesselName: "",
        voyage: "",
        createTime: [],
        startTime: "",
        endTime: "",
        polName: "",
        polId: "",
        podName: "",
        podId: "",
        vesselId: "",
        startEtd: new Date(
          new Date(
            new Date(
              new Date().getTime() - 24 * 1000 * 3600 * 60
            ).toLocaleDateString()
          ).getTime()
        ),
        endEtd: new Date(
          new Date(
            new Date(
              new Date().getTime() + 24 * 1000 * 3600 * 31
            ).toLocaleDateString()
          ).getTime() +
          24 * 1000 * 3600 -
          1
        ),
      },
      //标志点击哪个查询按钮
      queryButton: 0,
      //显示高级查询
      moreInfoVisible: false,
      //tab状态栏
      activeName: "all",
      //各订单状态数量
      count0: 0,
      //新增弹出框状态
      addVisible: false,
      //模板订舱弹出框状态
      templateBookingVisible: false,
      //保函上传弹出框状态
      uploadGuaranteeVisible: false,
      //Attachment下载弹出框状态
      downloadAttachmentVisible: false,
      //传递给复制/新增
      addOrCopyData: {},
      //订单状态列表
      ebOrderStatusList: [],
      // 表格数据
      ebOrderTableDataSource: [],
      //当前行数据
      currentEbOrder: {},
      // 表格设置
      tableSettings: {
        height: 526,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig
      },
      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
      // 船公司联想控件
      associate_columns_carrier: [

        {
          title: "中文简称",
          field: 'custAlias'
        },
        {
          title: "中文全称",
          field: 'custNameCn'
        },
        {
          title: "助记码",
          field: 'mnemonicCode'
        }
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      // 航次联想控件
      associate_columns_voyage: [{
        title: "航次",
        field: 'voyage'
      }],
      // 装/卸货港联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      //日期设置
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      pageID: {}
    };
  },
  async created() {

  },
  activated() {
    setTimeout(() => {
      this.$nextTick (() => {
        this.$refs.ebOrderTableRef.render()
      })
    },100);
  },
  computed: {
    nameComputed: {
      get: function () {
        return this.no;
      },
      set: function (val) {
        this.no = val.toUpperCase();
      }
    }
  },
  mounted() {
    let self = this;
    self.queryEbOrderStatus()
    self.queryEbOrderUubStatus()
    // 监听外层容器div宽度的变化，做表格自适应
    // self.pageID = document.getElementById('vgmContainer')、

    this.tableSettings.height = document.body.clientHeight - 100 -150;
  },
  methods: {
    changeEndEtd() {
      let self = this;
      self.searchData.endEtd = new Date(self.searchData.endEtd.getTime() + 1000 * 24 * 3600 - 100)
    },
    changeEndTime() {
      let self = this;
      self.searchData.endTime = new Date(self.searchData.endTime.getTime() + 1000 * 24 * 3600 - 100)
    },
    onPolChange(value,selectedRows){
      this.searchData.polId = selectedRows.mdPortId;
    },
    onPodChange(value,selectedRows){
      this.searchData.podId = selectedRows.mdPortId;
    },
    onChangeVessel() {
      let record = this.$refs.vesselAssociate.list[this.$refs.vesselAssociate.hoverIndex];
      this.searchData.vesselName = record.vesselName;
      this.searchData.voyage = record.voyage;
      this.searchData.vesselId = record.vesselId;
    },
    onChangeCarrier(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.searchData.carrierName = selectedRows.custNameCn;
      this.searchData.carrierId = selectedRows.csCustId;
    },
    giveCsCustId(value, selectedRows) {
      let self = this;
      self.searchData.csCustId = selectedRows.csCustId;
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({keyword, pageSize, currentPage}) {
      let params = {};
      let whereObj = null
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      if (this.searchData.vesselName) {
        params.vesselId = this.searchData.vesselId
        whereObj = "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)"
      } else {
        whereObj = "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)"
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where: whereObj,
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 装/卸货港联想控件数据源
    associate_queryMethod_po({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage(this.pageConfig.currentPage);
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    //excel导出
    vgmExport() {
      let self = this
      if (self.queryButton === 1) {
        ebOrder.exportExcel(self.no)
      } else if (self.queryButton === 2) {
        ebOrder.exportMoreExcel(self.searchData)
      }
    },
    // 新增按钮
    btnAdd() {
      this.$router.push({
        name: 'VGMAdd'
      })
    },
    // 单击
    clickMblNo(val) {
      let self = this;
      let row = val.record;
      if(val.col === 1) {
        self.$router.push({
          path: 'VGMEdit',
          params: row
        });
      }
    },
    // 双击
    dbClickMblNo(val) {
      let self = this;
      let row = val.record;
      sessionStorage.setItem('ebOrderParams', JSON.stringify([row]))
      sessionStorage.setItem('ebOrderType',  'edit')
      self.$router.push({
        name: "VGMEdit",
        params: {
          ebOrderId: row.ebOrderId,
          type: 'edit'
        },
      });
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      if (tab.name === "all") {
        self.ebOrderTableDataSource = self.ebOrderStatusAllList;
        return;
      }
      self.pageConfig.currentPage = 1;
      let target = self.ebOrderStatusList.find(
        (item) => item.value === tab.paneName
      );
      self.ebOrderTableDataSource = target.filterList;
      self.pageConfig.total = target.count
    },
    queryStatusPage() {
      let self = this;
      if (self.queryButton === 1) {
        self.queryForm();
      } else if (self.queryButton === 2) {
        self.queryMoreForm();
      }
    },
    changMoreInfoVisible() {
      this.moreInfoVisible = !this.moreInfoVisible
      if (this.moreInfoVisible) {
        this.tableSettings.height = this.tableSettings.height - 143
      }
      if(!this.moreInfoVisible) {
        this.tableSettings.height = this.tableSettings.height + 143
      }
    },
    // 重置
    resetForm() {
      this.no = "";
    },
    resetMoreForm() {
      this.searchData = {
        carrierName: "",
        vesselName: "",
        voyage: "",
        createTime: [],
        startTime: "",
        endTime: "",
        polName: "",
        podName: "",
        startEtd: new Date(
          new Date(
            new Date(
              new Date().getTime() - 24 * 1000 * 3600 * 60
            ).toLocaleDateString()
          ).getTime()
        ),
        endEtd: new Date(
          new Date(
            new Date(
              new Date().getTime() + 24 * 1000 * 3600 * 31
            ).toLocaleDateString()
          ).getTime() +
          24 * 1000 * 3600 -
          1
        ),
      }
    },

    //简单查询
    queryForm() {
      let self = this;
      self.queryButton = 1;
      if (self.no.trim().length === 0) {
        //self.$coreMethods.message('warning', '请输入单个或多个委托号;提单号;运编号')
        self.queryMoreForm();
      } else {
        let searchData = {
          page: self.pageConfig.currentPage,
          limit: self.pageConfig.pageSize,
          arrayNo: self.no.split(";"),
          //orderStatus: self.activeName === "all" ? "" : self.activeName,
        };
        //self.queryAll();
        if (searchData.arrayNo.length > 1) {
          ebOrder.queryEbOrderMore(searchData).then((res) => {
            console.log("queryEbOrder", res);
            if (res.success) {
              self.ebOrderTableDataSource = res.data.data;
              self.pageConfig.total = res.data.totalRecord;
              if (res.records.totalRecord === 0){
                self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
              }else {
                self.$coreMethods.message("success", "查询成功！");
              }
            }
          });
        } else {
          ebOrder.queryEbOrderMore1(searchData).then((res) => {
            console.log("queryEbOrder", res);
            if (res.success) {
              self.ebOrderTableDataSource = res.data.data;
              self.pageConfig.total = res.data.totalRecord;
              self.count0 = self.pageConfig.total = res.data.totalRecord;
              self.filterStatus(res.data.data);
              if (res.records.totalRecord === 0){
                self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
              }else {
                self.$coreMethods.message("success", "查询成功！");
              }
            }
          });
        }
      }
    },

    //高级查询
    queryMoreForm() {
      let self = this;
      //self.searchData.orderStatus = self.activeName === "all" ? "" : self.activeName;
      // if(self.searchData.endTime) self.searchData.endTime = new Date(self.searchData.endTime.getTime() - 24 * 60 * 60 -1)
      let searchColumns = [
        {
          propertyName: "carrierId",
          value: self.searchData.csCustId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "vesselId",
          value: self.searchData.vesselId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: 'voyage',
          value: self.searchData.voyage,
          operation: 'LIKE',
          connector: 'and'
        },
        {
          propertyName: 'createTime',
          aliasName: 'createTime',
          value: self.searchData.createTime,
          operation: 'BETWEEN',
          connector: 'and'
        },
        {
          propertyName: "startTime",
          aliasName: "createTime",
          value: self.searchData.startTime,
          operation: "GE",
          connector: "and",
        },
        {
          propertyName: "endTime",
          aliasName: "createTime",
          value: self.searchData.endTime,
          operation: "LE",
          connector: "and",
        },
        {
          propertyName: "startEtd",
          aliasName: "etd",
          value: self.searchData.startEtd,
          operation: "GE",
          connector: "and",
        },
        {
          propertyName: "endEtd",
          aliasName: "etd",
          value: self.searchData.endEtd,
          operation: "LE",
          connector: "and",
        },
        {
          propertyName: "polName",
          value: self.searchData.polName,
          operation: "LIKE",
          connector: "and",
        },
        {
          propertyName: "polId",
          value: self.searchData.polId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "podName",
          value: self.searchData.podName,
          operation: "LIKE",
          connector: "and",
        },
        {
          propertyName: "podId",
          value: self.searchData.podId,
          operation: "EQ",
          connector: "and",
        },
        // {
        //   propertyName: 'orderStatus',
        //   value: self.searchData.orderStatus,
        //   operation: 'LIKE',
        //   connector: 'and'
        // },
        {
          propertyName: 'transferStatus',
          value: 1,
          operation: 'NEQ',
          connector: 'and'
        },
      ];
      let query = {"searchColumns": searchColumns};

      self.queryButton = 2;
      let num = 0
      for (let s in self.searchData) {
        if (self.searchData[s] !== "") {
          num++
        }
      }
      if (num === 0) {
        self.$coreMethods.message('warning', '至少输入一个查询条件')
      } else {
        self.searchData.page = self.pageConfig.currentPage;
        self.searchData.limit = self.pageConfig.pageSize;
        self.searchData.orderStatus = self.activeName === "all" ? "" : self.activeName;

        let params = self.$daoServiceUtils.buildQueryParams(ebOrder, query, {
          page: self.pageConfig.currentPage,
          limit: self.pageConfig.pageSize
        })
        // self.queryAllMore();
        ebOrder.queryMoreEbOrder(params).then((res) => {
          if (res.success) {
            self.ebOrderTableDataSource = res.data.data;
            self.count0 = self.pageConfig.total = res.data.totalRecord;
            self.filterStatus(res.data.data);
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },

    //简单查询所有
    queryAll() {
      let self = this;
      let allSearchData = {
        arrayNo: self.no.trim().split(";"),
        orderStatus: "",
      };
      ebOrder.queryEbOrder(allSearchData).then((res) => {
        console.log("queryEbOrder", res);
        if (res.success) {
          self.filterStatus(res.data);
          if (res.records.totalRecord === 0){
            self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
          }else {
            self.$coreMethods.message("success", "查询成功！");
          }
        }
      });
    },
    //高级查询所有
    queryAllMore() {
      let self = this;
      let allSearchData = {
        carrierName: self.searchData.carrierName,
        vesselName: self.searchData.vesselName,
        voyage: self.searchData.voyage,
        startTime: self.searchData.createTime[0],
        endTime: self.searchData.createTime[1],
        polName: self.searchData.polName,
        podName: self.searchData.podName,
        orderStatus: "",
      };
      ebOrder.queryMoreEbOrder(allSearchData).then((res) => {
        console.log("queryMoreEbOrder", res);
        if (res.success) {
          self.filterStatus(res.data);
          if (res.records.totalRecord === 0){
            self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
          }else {
            self.$coreMethods.message("success", "查询成功！");
          }
        }
      });
    },
    // 各订单状态数量
    filterStatus(data) {
      let self = this;
      self.ebOrderStatusAllList = JSON.parse(JSON.stringify(data));
      self.initStatus();
      self.ebOrderStatusList.forEach((dictItem) => {
        let filterList = data.filter(
          (item) => dictItem.value === item.vgmApprovalStatus
        );
        dictItem.filterList = filterList;
        dictItem.count = filterList.length;
      });

      if(self.activeName !== 'all') {
        let targetStatus = self.ebOrderStatusList.find(item => item.value === self.activeName)
        self.ebOrderTableDataSource = targetStatus.filterList
      }
    },
    initStatus() {
      let self = this;
      self.ebOrderStatusList.forEach((dictItem) => {
        dictItem.count = 0;
      });
    },
    //获取vgm状态数据字典
    queryEbOrderStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$EB_VGM_STATUS').then(res => {
        let dict = []
        res.MD_CODE_DICT$EB_VGM_STATUS.forEach(item => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        });
        self.ebOrderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({EB_VGM_STATUS: dict});
      });
    },

    //获取vgm提交状态数据字典
    queryEbOrderUubStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$EB_VGM_SUB_STATUS').then(res => {
        let dict = [];
        res.MD_CODE_DICT$EB_VGM_SUB_STATUS.forEach(item => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        })
        self.ebOrderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({EB_VGM_SUB_STATUS: dict});
      });
    },
    /*queryEbOrderUubStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$EB_VGM_SUB_STATUS').then(res => {
        let dict = []
        res.MD_CODE_DICT$EB_VGM_SUB_STATUS.forEach(item => {
          let param = {}
          param.name = item.value
          param.value = item.key
          param.count = 0
          dict.push(param)
        })
        self.ebOrderStatusList = dict
        console.log("ebOrderStatusList", dict)
        // 数据字典
        self.$hotTableUtils.registDict({EB_VGM_SUB_STATUS: dict});
      })
    },*/
    //点击
    clickModule(e) {
      console.log("clickModule", e);
      let self = this;
      if (e === 1) {
        //编辑
        this.$router.push({
          name: "bookingAdd",
          params: {
            ebOrder: self.currentEbOrder,
          },
        });
      } else if (e === 2) {
        //复制
        let ebOrder = self.currentEbOrder;
        self.addOrCopyData = {
          copyFlag: 1,
          bizTypeCode: "MFEF",
          bizTypeName: "海运整箱出口",
          inputMethond: "M",
          orderType: "F",
          isCancelApply: 0,
          custId: ebOrder.custId,
          custName: ebOrder.custName,
          isLcl: 0,
          orderStatus: ebOrder.orderStatus,
          custBizNo: ebOrder.custBizNo,
          agreementNo: ebOrder.agreementNo,
          nameAccount: ebOrder.nameAccount,
          csId: ebOrder.csId,
          csName: ebOrder.csName,
          carrierSales: ebOrder.carrierSales,
          hblPaymentType: ebOrder.hblPaymentType,
          hblPaymentPlace: ebOrder.hblPaymentPlace,
          hblPaymentPlaceId: ebOrder.hblPaymentPlaceId,
          hblPaymentContact: ebOrder.hblPaymentContact,
          hblTransportTermFrom: ebOrder.hblTransportTermFrom,
          hblTransportTermTo: ebOrder.hblTransportTermTo,
          issueMode: ebOrder.issueMode,
          placeOfIssueName: ebOrder.placeOfIssueName,
          placeOfIssueId: ebOrder.placeOfIssueId,
          noOfOriginal: ebOrder.noOfOriginal,
          noOfCopy: ebOrder.noOfCopy,
          custContact: ebOrder.custContact,
          custContactTel: ebOrder.custContactTel,
          custContactEmail: ebOrder.custContactEmail,
          porId: ebOrder.porId,
          porName: ebOrder.porName,
          porCode: ebOrder.porCode,
          polId: ebOrder.polId,
          polName: ebOrder.polName,
          polCode: ebOrder.polCode,
          potId: ebOrder.potId,
          potName: ebOrder.potName,
          potCode: ebOrder.potCode,
          podId: ebOrder.podId,
          podName: ebOrder.podName,
          podCode: ebOrder.podCode,
          placeOfDeliveryId: ebOrder.placeOfDeliveryId,
          placeOfDeliveryName: ebOrder.placeOfDeliveryName,
          placeOfDeliveryCode: ebOrder.placeOfDeliveryCode,
          bargeTransitPortCode: ebOrder.bargeTransitPortCode,
          carrierId: "根据对话框中选择的船公司赋值",
          carrierName: "根据对话框中选择的船公司赋值",
          isDeleted: 0,
          vgmStatus: "UNSENT",
          vgmApprovalStatus: "NEW",
        };
        self.addVisible = !self.addVisible;
      } else {
        //下载附件
        self.addOrCopyData = self.currentEbOrder;
        self.downloadAttachmentVisible = !self.downloadAttachmentVisible;
      }
    },
    //批量提交
    batchSubmit() {
      /*let self = this;
      let flag = true;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message('warning', '请勾选记录')
      } else {
        params.forEach(item => {
          //判断选中的订单状态为草稿
          if (item.vgmApprovalStatus != 'NEW') {
            flag = false;
          }
        });
        if (!flag) {
          self.$coreMethods.message('warning', '请选择状态为草稿的记录')
        } else {
          batchSubmitVGM(params).then(res => {
            if (res.success) {
              self.$coreMethods.message('success', '批量提交成功')
              self.queryStatusPage()
            } else {
              self.$coreMethods.message('error', '批量提交失败')
            }
          })
        }
      }*/
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      let ebOrderIdsArr = []
      let ebOrderStatus = []
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else {
        params.forEach((item) => {
          ebOrderStatus.push(item.orderStatus)
          ebOrderIdsArr.push(item.ebOrderId)
        });
        if (new Set(ebOrderStatus).size === 1) {
          if (ebOrderStatus[0] === "NEW") {
            batchSubmit({ebOrderIds: ebOrderIdsArr, dataType: "ORDER"}).then((res) => {
              if (res.success) {
                self.$coreMethods.message("success", "批量提交成功");
                self.queryStatusPage();
              } else {
                self.$coreMethods.message("error", "批量提交失败");
              }
            });
          } else {
            self.$coreMethods.message("warning", "请选择状态为草稿的记录");
          }
        } else {
          self.$coreMethods.message("warning", "请选择状态为草稿的记录");
        }
      }
    },
    //上传保函
    uploadGuarantee() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
      }
      self.uploadGuaranteeVisible = true;
      self.$refs.uploadGuaranteeUpBoxRef.setEbOrderId(params[0].ebOrderId);
    },
    //状态历史
    statusHistory() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        this.$router.push({
          name: "StatusHistory",
          params: {
            orderNo: "params[0].orderNo",
          },
        });
      }
    },
    //制作提单
    makeBLN() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message("waring", "请勾选记录");
        return;
      }
      if (params.length > 1) {
        self.$coreMethods.message("waring", "请勾选一条记录");
        return;
      }
      self.$router.push({
        name: "ladingbillEdit",
        params: {
          ebOrderId: params[0].ebOrderId,
          type: 'edit'
        },
      });
    },
    //维护vgm
    maintainVGM() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        if (
          params[0].orderStatus === "CRM" &&
          params[0].mblNo !== null &&
          params[0].mblNo !== ""
        ) {
          ebFtPlan.getCountByEbOrderId(params[0].ebOrderId).then((res) => {
            if (res.data.length > 0) {
              self.$coreMethods.message(
                "error",
                "已做过舱单，不能重复制作舱单"
              );
            } else {
              let ebOrder = params[0];
              ebOrder.vgmApprovalStatus = "NEW";
              ebOrder.vgmStatus = "UNSENT";
              this.$router.push({
                name: "VGMEdit",
                params: {
                  ebOrder: ebOrder,
                },
              });
            }
          });
        } else {
          // self.$coreMethods.message("warning", "请选择已提交的记录");
          self.$coreMethods.message("warning", "请勾选已接收的订单");
        }
      }
    },
    //撤销提交
    revokeUpdating() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      let ebOrderIdsArr = []
      let orderStatusArr = []
      let orderStatus = ""
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else {
        params.forEach((item) => {
          orderStatusArr.push(item.orderStatus)
          ebOrderIdsArr.push(item.ebOrderId)
        });
        if (new Set(orderStatusArr).size === 1) {
          if (orderStatusArr[0] === 'SUB') {
            orderStatus = "NEW"
          } else if (orderStatusArr[0] === 'UPDSUB') {
            orderStatus = "CRM"
          }
          self.$coreMethods.confirm(function () {
            batchRevokeSub({"ebOrderIds": ebOrderIdsArr, "orderStatus": orderStatus}).then((res) => {
              if (res.success) {
                params.forEach((item) => {
                  item.orderStatus = orderStatus
                });
                self.$coreMethods.message("success", "撤销提交成功");
                self.submitVisible = true;
              } else {
                self.$coreMethods.message("error", "撤销提交失败");
              }
            });
          }, function () {
          }, false, '是否执行撤销操作？')
        } else {
          self.$coreMethods.message("warning", "请确认订单状态为是否全为新增提交或者全为修改提交");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs__content {
  display: none;
}
</style>
